
import axios from '../http'
import store from '../config/store'

export default {
  
  data: () => ({
    store,
    currencies: [],
    correspondent: {},
    selectedCurrency: 978
  }),
  
  computed: {
    account () {
      return store.data.user.account
    }
  },
  
  watch: {
    selectedCurrency () {
      this.getCurrencyDetails()
    }
  },
  
  mounted () {
    this.getCurrenciesList()
    this.getCurrencyDetails()
  },
  
  methods: {
    getCurrencyDetails () {
      axios.get(`/currencies/${this.selectedCurrency}/correspondent`).then((response) => {
        this.correspondent = response.data
      })
    },
    getCurrenciesList () {
      axios.get('/currencies').then((response) => {
        this.currencies = response.data
      })
    },
    downloadRibDevise () {
      this.downloadFileFromUrl(`/account/rib/${this.selectedCurrency}`)
    }
  }

}
